module.exports = __webpack_public_path__ + "static/burak-omer-ogulturk-b94fdf1b0b7729cf2140644664a74e99.png";